import { render, staticRenderFns } from "./OrderCounterSummary.vue?vue&type=template&id=aea15dcc&scoped=true&"
import script from "./OrderCounterSummary.vue?vue&type=script&lang=js&"
export * from "./OrderCounterSummary.vue?vue&type=script&lang=js&"
import style0 from "./OrderCounterSummary.vue?vue&type=style&index=0&id=aea15dcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea15dcc",
  null
  
)

export default component.exports